import parameterSegment from "./parameterSegment.js";

/**
 * Optional parameters can have a default value.
 *
 * @param {object} spec abstractSegment string
 * @param my
 * @returns {parameter}
 */
const optionalParameterSegment = parameterSegment.subclass((that, my) => {
	my.initialize = function (spec) {
		my.super(spec);
		my.defaultValue = my.options.defaults && my.options.defaults[my.name];
	};

	//
	// Public
	//

	/**
	 * Parameter value or default value if not matched.
	 *
	 * @param {string} urlSegment
	 * @returns {unknown}
	 */
	that.getValue = function (urlSegment) {
		return urlSegment === undefined ? my.defaultValue : urlSegment;
	};

	/**
	 * Always true.
	 * @returns {boolean}
	 */
	that.isOptional = function () {
		return true;
	};

	/**
	 * String representation for segment that can be used eg. when debugging.
	 * @returns {string}
	 */
	that.toString = function () {
		return `optional(${that.getName()})`;
	};
});

optionalParameterSegment.class((that) => {
	/**
	 * Match segment strings with a leading `?`.
	 * @param {string} segmentString
	 * @returns {boolean}
	 */
	that.match = function (segmentString) {
		return segmentString.substr(0, 1) === "?";
	};
});
